import React from 'react';
const BONUSES = [{
  emoji: '🎁',
  title: 'BONO 1 — Registro de Avances Terapéuticos',
  meta: '3 versiones: niños / adolescentes / adultos',
  desc: 'Documento visual que completás con el paciente sesión a sesión. Con línea de base métricas de evolución y carta de cierre. Cuando la familia pregunta si el paciente mejora dejás de decir "sí está avanzando" y empezás a mostrar.',
  img: 'https://cdn.magicpatterns.com/uploads/qZgp8ahHaWfXVp19cCa4Jq/90685943-4f30-456f-9f02-31a583e0fb53-removebg-preview.png',
  contain: true
}, {
  emoji: '🎁',
  title: 'BONO 2 — Cuaderno Emocional del Hablante',
  meta: '3 versiones: niños / adolescentes / adultos · 28 días de reflexión guiada',
  desc: 'Para que el paciente trabaje solo en casa entre sesiones. Sin necesitar al terapeuta presente. El trabajo entre sesiones es tan importante como el trabajo en sesión.',
  img: 'https://cdn.magicpatterns.com/uploads/c7xWQDt7kXqmwP23cYXw5n/fcb94ad7-95b8-45ce-a1ba-d511a227c87b-removebg-preview.png',
  contain: true
}, {
  emoji: '🎁',
  title: 'BONO 3 — Guía Anti-Bullying para Familias y Colegios',
  meta: '2 partes: para familias y para docentes · Lenguaje accesible sin tecnicismos',
  desc: 'El material que le das a los padres y al docente el primer día y que pueden leer solos. Con señales de alerta protocolos de intervención y plan de protección.',
  img: 'https://cdn.magicpatterns.com/uploads/9BktVP5Bt91wiHxkag8Bij/ChatGPT_Image_11_may_2026__07_03_10_p.m.-removebg-preview.png',
  contain: true
}, {
  emoji: '🎁',
  title: 'BONO 4 — Planificador Terapéutico Mensual',
  meta: '3 versiones: niños / adolescentes / adultos · Con cronograma sugerido por diagnóstico',
  desc: 'El organizador que convierte 540 fichas en un protocolo sesión por sesión. Sin este bono tenés fichas. Con este bono tenés un sistema.',
  img: 'https://cdn.magicpatterns.com/uploads/jQpapSpQyhJ3L4B5HWLoUr/14a577d5-e48e-47a8-8600-9fdb4345dee2-removebg-preview.png',
  contain: true
}, {
  emoji: '🎁',
  title: 'BONO 5 — 100 Frases de Apoyo para Padres',
  meta: '10 categorías · 100 frases validadas clínicamente',
  desc: 'Las palabras exactas para cuando el niño se traba cuando llega triste del colegio cuando dice que odia cómo habla y cuando pregunta si se va a curar. Y las 15 frases que nunca hay que decir aunque la intención sea buena.',
  img: 'https://cdn.magicpatterns.com/uploads/nKyD8asBixQuvMJeWoGXY1/d3bc3741-e4a0-4880-a636-8d2a88552343-removebg-preview.png',
  contain: true
}, {
  emoji: '🎁',
  title: 'BONO 6 — Kit de Juegos Terapéuticos Imprimibles',
  meta: '6 juegos · Para niños de 4 a 11 años · Listos para plastificar y usar',
  desc: 'El dado del habla suave · El camino de la fluidez · Cartas de situaciones · El semáforo del habla · Bingo de sonidos · El termómetro del habla.',
  img: 'https://cdn.magicpatterns.com/uploads/ddcegM4wF7rg1aGA7WjMAW/9ac9b327-2178-46a8-a48e-41218084351a-removebg-preview.png',
  contain: true
}, {
  emoji: '🎁',
  title: 'BONO 7 — 50 Actividades de Fluidez Listas para Usar',
  meta: '50 actividades de 5 a 10 minutos · 6 técnicas · Con variante por edad',
  desc: 'Para el calentamiento de sesión el cierre o la tarea de la semana. Organizadas por técnica: ritmo respiración coordinación pausas prolongación y habla libre.',
  img: 'https://cdn.magicpatterns.com/uploads/n7WThMWygRhe8FRasMNiPW/09922d2e-6d86-4dac-99cf-e8657e9f1f09-removebg-preview.png',
  contain: true
}, {
  emoji: '🎁',
  title: 'BONO 8 — Rutinas Semanales de Práctica en Casa',
  meta: '12 versiones: 4 módulos × 3 grupos etarios · 10 a 20 minutos diarios',
  desc: 'El puente entre sesiones. Estructura la práctica de los 6 días que el paciente no está en el consultorio. Con registro de adherencia y tarjeta de compromiso.',
  img: 'https://cdn.magicpatterns.com/uploads/hn5RHRjcTnNNpc4V2GhR4i/06d6dde5-c96e-4498-971e-dc5214707201-removebg-preview.png',
  contain: true
}];
export function Bonuses() {
  return <section className="flex flex-col gap-8 py-12 bg-[#0F4C3A] text-white -mx-5 px-5 md:rounded-3xl md:mx-0" data-id="element-15">
      <div className="flex flex-col gap-4 text-center" data-id="element-16">
        <h3 className="font-serif text-3xl font-bold text-[#FBF8F3]" data-id="element-17">
          Más 8 bonos incluidos sin costo adicional
        </h3>
        <div className="bg-[#D97757] text-white font-bold py-2 px-4 rounded-lg inline-block self-center uppercase tracking-wider text-sm" data-id="element-18">
          GRATIS POR EL DÍA DE HOY
        </div>
      </div>

      <div className="flex flex-col gap-8" data-id="element-19">
        {BONUSES.map((bonus, idx) => <div key={idx} className="flex flex-col bg-white text-stone-900 rounded-2xl overflow-hidden shadow-lg" data-id="element-20">
            <a href="#compra" className="flex flex-col cursor-pointer hover:opacity-95 transition-opacity" data-id="element-21">
              <img src={bonus.img} alt={bonus.title} className={bonus.contain ? 'w-full h-96 object-contain bg-[#FBF8F3] border-b border-stone-100 p-4' : 'w-full h-48 object-cover border-b border-stone-100'} data-id="element-22" />
            </a>
            <div className="flex flex-col p-6 text-center gap-3" data-id="element-23">
              <span className="text-4xl" data-id="element-24">{bonus.emoji}</span>
              <h4 className="font-serif text-xl font-bold text-[#0F4C3A]" data-id="element-25">
                {bonus.title}
              </h4>
              <p className="text-xs font-bold text-[#D97757] uppercase tracking-wide" data-id="element-26">
                {bonus.meta}
              </p>
              <p className="text-stone-600 font-medium" data-id="element-27">{bonus.desc}</p>
            </div>
          </div>)}
      </div>
    </section>;
}